import React from 'react';
import { useSelector } from 'react-redux';
import { cn } from '@/utils/cn';
import TagBadge from '../../Badge/TagBadge';

function ProductCardTagList({ tags, className }) {
  const { lang } = useSelector((state) => state.globalSettings);

  if (!tags || (Array.isArray(tags) && tags.length === 0)) {
    return <div className={cn('empty-tag h-[24px] lg:h-[28px]', className)} />;
  }

  return (
    <div
      className={cn(
        'h-[24px] lg:h-[28px] flex items-center overflow-hidden',
        className,
      )}
    >
      {tags?.length > 0 &&
        tags
          ?.slice(0, 3)
          .map(
            (tag) =>
              tag?.short_name &&
              tag?.short_name !== null && (
                <TagBadge
                  key={`${tag.slug}`}
                  icon={tag?.icon ?? null}
                  label={tag?.short_name[lang]}
                />
              ),
          )}
    </div>
  );
}

export default ProductCardTagList;
